document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("product-card").forEach((card) => {
        let figure = card.querySelector(".product-card__figure"); // Sélectionne l'image du produit
        if (!figure) return; // Vérifie si l'élément existe

        // Créer un conteneur pour les besoins
        let besoinsWrapper = document.createElement("div");
        besoinsWrapper.classList.add("product-besoins");

        // Liste des besoins (peut être dynamique selon le produit)
        let besoins = ["", ""];

        // Ajouter chaque besoin dans un <span>
        besoins.forEach((besoin) => {
            let span = document.createElement("span");
            
            span.textContent = besoin;
            besoinsWrapper.appendChild(span);
        });

        // Insérer les besoins en PREMIER dans `.product-card__figure`
        figure.prepend(besoinsWrapper);
    });
});
